import React from 'react';

import Layout from '../../components/Layout';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import Button from '../../components/Button';

import { useMediaQuery } from 'react-responsive';
import paths from '../../routes/paths';

import { Container, Paragraph, ButtonContainer, Icon } from './styles';
import { Images } from '../../themes';

export default function NotFound() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  return (
    <Layout activeRoute="activate" mapImageOnBackground={!isMobile}>
      <Container>
        <Icon src={Images.icons.alert} alt={'alert'} />
        <Title>
          Oops! <highlight>Something went wrong</highlight>
        </Title>
        <Subtitle text="we´re sorry to say but you will have to start again" />
        <Paragraph>
          Something went wrong in the process and we a get an not expected
          error, please start the activation again on the button bellow.
        </Paragraph>
        <ButtonContainer>
          <Button
            onClick={() => (window.location = paths.home)}
            icon={Images.icons.instation}
            alt={'InStation logo'}
            fullWidth
            text={'Return to the previous page'}
          />
        </ButtonContainer>
        <Subtitle text="It is fast and we will help you out!" />
      </Container>
    </Layout>
  );
}
